import { takeLatest, all, call, put } from "redux-saga/effects";
import {
  startUserLogin,
  startCompanyData,
  setCompanyData,
  setUserData,
  startUserLogout,
  setNullAfterLogout,
  setTrueOnRefreshPage,
  setUserPermissions,
  startTogetRefreshToken,
  completedFetch,
} from "./user.login.data.slice.slector";
import {
  refreshAuthToken,
  loginUserAuthRequest,
  logoutUserApi,
  getMyCompanyData,
} from "../../Api/UserAuthAPI/userAuth";
import { setNotificationAction } from "store1/NotificationStore/notification.slice.selector";

function* startLoginData() {
  yield takeLatest(startUserLogin.type, setData);
}

function* setData({ payload }) {
  try {
    const response = yield call(loginUserAuthRequest, payload);
    yield put(setUserData(response));

    const perms = response?.permission;

    if (Array.isArray(perms)) {
      const flatPermissions = perms.flatMap(item => item.permission || []);
      const uniquePermissions = [...new Set(flatPermissions)];
      yield put(setUserPermissions(uniquePermissions));
    }

    yield put(completedFetch());
    yield put(
      setNotificationAction({
        message: `Logged-In Successfully`,
        variant: 'success',
      })
    );
  } catch (error) {
    yield put(
      setNotificationAction({
        message: `${error.response.data}`,
        variant: 'error',
      })
    );
    yield put(completedFetch());
  }
}

function* startRefreshToken() {
  yield takeLatest(startTogetRefreshToken.type, setRefData);
}

export function* setRefData() {
  try {
    const response = yield call(refreshAuthToken);
    yield put(setTrueOnRefreshPage());
    const data = yield call(getMyCompanyData);
    yield put(setCompanyData(data));
    yield put(setUserData(response));
    yield put(completedFetch());
  } catch (error) {
    yield call(setLogoutData);
    yield put(completedFetch());
  }
}

function* startLogoutData() {
  yield takeLatest(startUserLogout.type, setLogoutData);
}
function* setLogoutData() {
  yield call(logoutUserApi);
  yield put(setNullAfterLogout());
  yield put(completedFetch());
}

function* startGetCompanyData() {
  yield takeLatest(startCompanyData.type, setMyCompanyData);
}

function* setMyCompanyData({ payload }) {
  try {

    const data = yield call(getMyCompanyData, payload);
    yield put(setCompanyData(data));
    yield put(completedFetch());
  } catch (error) {
    yield put(setNotificationAction({
      message: error,
      variant: 'error'
    }))
  }
}
//Accumulator
export default function* userDataSaga() {
  yield all([
    call(startLoginData),
    call(startLogoutData),
    call(startRefreshToken),
    call(startGetCompanyData),
  ]);
}
